import React, { useEffect, useState } from 'react'
import './TakeAttendance.css'
import { Check, CircleCheck } from 'lucide-react'
import axios from './../../axios'
import AttendancePop from './AttendancePopUp'
import { toast } from 'react-toastify'
import ConfirmationPopUp from './ConfirmationPopUp'

function TakeAttendance() {
    const studentData = JSON.parse(localStorage.getItem('breathForStudent'))
    const [selectedStatus, setSelectedStatus] = useState('');
    const [isPopUpOpen, setIsPopUpOpen] = useState(false);
    const [isConfirmPopUp, setIsConfirmPopUp] = useState(false);
    const [inputValue, setInputValue] = useState('')
    const [currentTime, setCurrentTime] = useState(new Date());

    const handleStatusChange = (status) => {
        setSelectedStatus(status)
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(new Date())
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    const formatDate = (isoDate) => {
        const date = new Date(isoDate);
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    };

    const handleOnSubmitAttendance = async () => {
        const body = {
            academicSessionId: studentData?.academic_session?.id,
            timetableSessionId: studentData?.timetable_session?.id,
            standardId: studentData?.standard?.id,
            sectionId: studentData?.section?.id,
            attendanceDate: formatDate(new Date()),
            attendanceDetails: [{
                studentId: studentData.id,
                status: selectedStatus,
                reason: inputValue,
            }],
        }
        try {
            const response = await axios.post(`/attendance/create`, body)
            // const response = await axios.post(`/attendance/submit`, body)
            response && toast.success("Your attendance has been marked successfully.")
        } catch (error) {
            console.log("error", error)
            toast.error("Something went wrong while marking attendance!!")
        } finally {
            setIsPopUpOpen(false)
        }
    }
    const statusOptions = [
        { label: 'Present', value: 'present' },
        { label: 'Absent', value: 'absent' },
        { label: 'Delay', value: 'delay' },
        { label: 'Leave', value: 'leave' },
    ];

    useEffect(() => {
        const getStudentAttendanceDetails = async () => {
            try {
                const resp = await axios.get(`/leaveMngmt/getStudentDetails?academicSessionId=${studentData?.academic_session?.id}&timetableSessionId=${studentData?.timetable_session?.id}&standardId=${studentData?.standard?.id}&sectionId=${studentData?.section?.id}&startDate=${new Date()}&endDate=${new Date()}&studentId=${studentData?.id}`)
                const existingStatus = resp?.data?.data?.attendanceRecords[0]?.status;
                if (existingStatus) {
                    setSelectedStatus(existingStatus);
                }
            } catch (error) {
                console.log("error", error)
            }
        }
        getStudentAttendanceDetails()
    }, [])

    return (
        <div className='row p-4'>
            <div className="col-md-4 faceAuth-main">
                <div className="takeattText">Take Attendance</div>
                <div className='studFaceUI'>
                    <img src='/StudentImg/studentImg.png' alt='stuIcon' className="studIcon" />
                    <div >Face Authentication</div>
                </div>
                <CircleCheck size={30} strokeWidth={3} color='green' className='tickIcon' />
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-7 faceAuth-main">
                <div className='todayDate text-xl font-bold text-blue-800'>
                    <span className="text-muted-foreground">
                        {new Date().toLocaleDateString('en-US', {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                        })} {` | `}
                        {currentTime.toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                        })}
                    </span>
                </div>
                <table className="table-container">
                    <thead>
                        <tr style={{ textAlign: "center" }}>
                            <th style={{ color: "blue" }}>Present</th>
                            <th style={{ color: "red" }}>Absent</th>
                            <th style={{ color: "orange" }}>Delay</th>
                            <th style={{ color: "green" }}>Leave</th>
                        </tr>
                    </thead>
                    <tbody>
                        {statusOptions.map(({ label, value }) => (
                            <td key={label}>
                                <div className="radio-container">
                                    <input
                                        type="radio"
                                        name={`attendance-${studentData.id}`}
                                        value={label}
                                        checked={selectedStatus === label}
                                        onChange={() => handleStatusChange(label)}
                                    />
                                </div>
                            </td>
                        ))}
                    </tbody>
                </table>
                <div>
                    <button className='mark_attendance_button' onClick={() => {
                        if (selectedStatus !== 'Delay' && selectedStatus !== 'Leave') {
                            setIsConfirmPopUp(true)
                        } else {
                            setIsPopUpOpen(true)
                        }
                    }}>Submit Attendance</button>
                </div>
            </div>
            {
                isPopUpOpen && <AttendancePop setInputValue={setInputValue} setIsPopUpOpen={setIsPopUpOpen} selectedStatus={selectedStatus} formatDate={formatDate} setIsConfirmPopUp={setIsConfirmPopUp} isConfirmPopUp={isConfirmPopUp} />
            }
            {
                isConfirmPopUp && <ConfirmationPopUp setIsConfirmPopUp={setIsConfirmPopUp} handleOnSubmitAttendance={handleOnSubmitAttendance} />
            }
        </div>
    )
}

export default TakeAttendance